export default __webpack_public_path__ + "static/media/dashboard.007090e2.jpg";